import { err, ok, Result } from '@easeltv/fail';

import { ApiFail } from '../errors';
import { RequestMethod } from '../utils/types';

/**
 * formatBody
 *
 * Return the request body in a format that can be sent with fetch
 *
 * @param body
 * @returns
 */
export const formatBody = (
    body?: Record<string, unknown> | File,
): BodyInit | undefined => {
    if (!body) return undefined;

    if (body instanceof Blob) return body;

    return JSON.stringify(body);
};

/**
 * makeRequest
 *
 * Method to make the actual fetch request
 *
 * @param method
 * @param url
 * @param headers
 * @param body
 */
export const makeRequest = async (
    method: RequestMethod,
    url: string,
    abortController: AbortController,
    headers?: Record<string, string>,
    body?: Record<string, unknown> | File,
): Promise<Result<Response, ApiFail>> => {
    try {
        const response = await fetch(url, {
            method,
            headers,
            body: formatBody(body),
            signal: abortController.signal,
        });

        return ok(response);
    } catch (error) {
        return err(
            new ApiFail({
                data:
                    error instanceof Error
                        ? error.message
                        : JSON.stringify(error),
                key: 'client.request.fail',
                description: 'Unable to perform request',
                name: 'Request Failed',
            }),
        );
    }
};
